"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactWindow = require("react-window");

var _propTypes = require("prop-types");

var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));

var _children = require("../../helpers/children");

var _Head = _interopRequireDefault(require("../Head"));

var _Row = _interopRequireDefault(require("../Row"));

var _Body = _interopRequireDefault(require("../Body"));

var _data = require("../data");

var _header = require("../header");

var _SortableColumns = _interopRequireWildcard(require("../SortableColumns"));

var _styler = _interopRequireDefault(require("../../Styler/styler"));

var _utils = require("../utils");

var _compareElementType = _interopRequireDefault(require("../../helpers/compare-element-type"));

var _getNativeProps = _interopRequireDefault(require("../../helpers/get-native-props"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function isScrollable(scroll) {
  // CD-DEPENDENCY: This paddingRight uses cobalt design's scrollbar width of 12.8px to offset the table headers in order to align properly with the table's content
  return scroll ? {
    paddingRight: 'var(--scrollbar-width)'
  } : null;
}

var VirtualizedTable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(VirtualizedTable, _React$PureComponent);

  function VirtualizedTable() {
    _classCallCheck(this, VirtualizedTable);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualizedTable).apply(this, arguments));
  }

  _createClass(VirtualizedTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          sortable = _this$props.sortable,
          striped = _this$props.striped,
          bordered = _this$props.bordered,
          selectable = _this$props.selectable,
          rowHeight = _this$props.rowHeight,
          headerHeight = _this$props.headerHeight,
          fontSmall = _this$props.fontSmall,
          borderless = _this$props.borderless,
          fullWidth = _this$props.fullWidth,
          itemKey = _this$props.itemKey,
          scrollableHeight = _this$props.scrollableHeight;
      var tableHeader = (0, _children.getFirstDirectChildOfTypes)(children, [_Head.default]);
      var tableBody = (0, _children.getFirstDirectChildOfTypes)(children, [_Body.default]);
      var tableStyles = ['co-table', 'co-table--scrollable', _defineProperty({
        'co-table--sortable': sortable,
        'co-table--striped': striped,
        'co-table--bordered': bordered,
        'co-table--selectable': selectable
      }, "co-table--scrollable--".concat(scrollableHeight), scrollableHeight)];
      var allowedModifiers = {
        fontSmall: fontSmall,
        borderless: borderless,
        fullWidth: fullWidth
      };
      return _react.default.createElement(_styler.default, {
        classNames: tableStyles,
        modifiers: allowedModifiers
      }, function (styles) {
        return _react.default.createElement(_reactVirtualizedAutoSizer.default, {
          defaultHeight: 1000,
          disableWidth: true,
          className: styles
        }, function (_ref2) {
          var width = _ref2.width,
              height = _ref2.height;
          var bodyHeight = scrollableHeight || height - headerHeight;
          var _tableBody$props = tableBody.props,
              data = _tableBody$props.data,
              renderRow = _tableBody$props.renderRow,
              bodyChildren = _tableBody$props.children;

          var bodyRows = data || _react.default.Children.toArray(bodyChildren);

          var scrollable = rowHeight * bodyRows.length > bodyHeight;
          return _react.default.createElement(_react.default.Fragment, null, tableHeader ? _react.default.createElement(VirtualHeader, {
            scrollable: scrollable,
            sortable: sortable
          }, tableHeader.props.children) : null, _react.default.createElement(VirtualBody, {
            rowHeight: rowHeight,
            width: width,
            height: bodyHeight,
            itemKey: itemKey,
            data: data,
            renderRow: data ? renderRow : false
          }, bodyChildren));
        });
      });
    }
  }]);

  return VirtualizedTable;
}(_react.default.PureComponent);

var VirtualHeader =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(VirtualHeader, _React$PureComponent2);

  function VirtualHeader() {
    _classCallCheck(this, VirtualHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualHeader).apply(this, arguments));
  }

  _createClass(VirtualHeader, [{
    key: "render",
    value: function render() {
      var sortable = this.props.sortable;
      return sortable ? _react.default.createElement(VirtualSortableHeadRows, this.props) : _react.default.createElement("div", {
        className: "co-table__head"
      }, _react.default.createElement(VirtualHeadRows, this.props));
    }
  }]);

  return VirtualHeader;
}(_react.default.PureComponent);

var VirtualHeadRows =
/*#__PURE__*/
function (_React$PureComponent3) {
  _inherits(VirtualHeadRows, _React$PureComponent3);

  function VirtualHeadRows() {
    _classCallCheck(this, VirtualHeadRows);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualHeadRows).apply(this, arguments));
  }

  _createClass(VirtualHeadRows, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          scrollable = _this$props2.scrollable,
          children = _this$props2.children;
      var headRow = (0, _children.getFirstDirectChildOfTypes)(children, [_Row.default]);
      return _react.default.createElement(VirtualRow, _extends({
        header: true,
        rowStyle: isScrollable(scrollable)
      }, headRow.props), headRow.props.children);
    }
  }]);

  return VirtualHeadRows;
}(_react.default.PureComponent);

var VirtualSortableHeadRows =
/*#__PURE__*/
function (_React$PureComponent4) {
  _inherits(VirtualSortableHeadRows, _React$PureComponent4);

  function VirtualSortableHeadRows() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VirtualSortableHeadRows);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VirtualSortableHeadRows)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "processHeaders", function (sorting, updateSortDirectionByIndex) {
      return function (header, headerIndex) {
        var _header$props = header.props,
            children = _header$props.children,
            alignment = _header$props.alignment,
            truncated = _header$props.truncated,
            sortable = _header$props.sortable,
            width = _header$props.width;
        var sortSequence = header.props.sortSequence || Object.values(header.SORT_DIRECTION);
        var currentIndex = sorting[headerIndex].currentIndex;
        var sortDirection = sorting[headerIndex].sortingDirection || sortSequence[currentIndex % sortSequence.length] || false;
        var headerClasses = ['co-table__head-cell', _defineProperty({
          'co-table__header--sortable': sortable
        }, "co-table__header--".concat(sortDirection), sortable && sortDirection), (0, _utils.widthClass)(width)];
        return _react.default.createElement(_styler.default, {
          classNames: headerClasses,
          modifiers: {
            alignment: alignment,
            truncated: truncated
          }
        }, function (styles) {
          return _react.default.createElement("div", {
            className: styles,
            onClick: sortable ? function () {
              updateSortDirectionByIndex(headerIndex);
            } : undefined
          }, children);
        });
      };
    });

    return _this;
  }

  _createClass(VirtualSortableHeadRows, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _getHeadersInfo = (0, _SortableColumns.getHeadersInfo)(this.props.children),
          headers = _getHeadersInfo.headers;

      return _react.default.createElement(_SortableColumns.default, {
        headers: headers
      }, function (_ref4) {
        var sorting = _ref4.sorting,
            updateSortDirectionByIndex = _ref4.updateSortDirectionByIndex;
        return _react.default.createElement("div", {
          className: "co-table__head"
        }, _react.default.Children.map(_this2.props.children, function (row) {
          return _react.default.createElement(_styler.default, {
            classNames: 'co-table__row',
            modifiers: _objectSpread({}, row.props)
          }, function (styles) {
            return _react.default.createElement("div", {
              className: styles,
              style: isScrollable(_this2.props.scrollable)
            }, _react.default.Children.map(row.props.children, _this2.processHeaders(sorting, updateSortDirectionByIndex)));
          });
        }));
      });
    }
  }]);

  return VirtualSortableHeadRows;
}(_react.default.PureComponent);

var VirtualBody =
/*#__PURE__*/
function (_React$PureComponent5) {
  _inherits(VirtualBody, _React$PureComponent5);

  function VirtualBody() {
    _classCallCheck(this, VirtualBody);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualBody).apply(this, arguments));
  }

  _createClass(VirtualBody, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          width = _this$props3.width,
          height = _this$props3.height,
          children = _this$props3.children,
          rowHeight = _this$props3.rowHeight,
          itemKey = _this$props3.itemKey,
          data = _this$props3.data,
          renderRow = _this$props3.renderRow;
      var useLazyRender = !!(renderRow && data);
      var itemData = useLazyRender ? {
        itemData: data,
        renderRow: renderRow
      } : _react.default.Children.toArray(children);
      var itemCount = useLazyRender ? data.length : itemData.length;
      var rowRenderer = useLazyRender ? VirtualRowRenderer : VirtualBodyRows;
      return _react.default.createElement(_reactWindow.FixedSizeList, {
        itemCount: itemCount,
        itemSize: rowHeight,
        itemData: itemData,
        itemKey: itemKey,
        height: height,
        width: width,
        className: "co-table__body"
      }, rowRenderer);
    }
  }]);

  return VirtualBody;
}(_react.default.PureComponent);

var VirtualRowRenderer = function VirtualRowRenderer(_ref5) {
  var data = _ref5.data,
      index = _ref5.index,
      style = _ref5.style;
  var itemData = data.itemData,
      renderRow = data.renderRow;
  return _react.default.createElement(VirtualRow, _extends({
    rowStyle: style
  }, itemData[index].props), renderRow(itemData[index]).props.children);
}; // This component is called for every row of the Table so it is very sensitive to performance!


var VirtualBodyRows =
/*#__PURE__*/
function (_React$PureComponent6) {
  _inherits(VirtualBodyRows, _React$PureComponent6);

  function VirtualBodyRows() {
    _classCallCheck(this, VirtualBodyRows);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualBodyRows).apply(this, arguments));
  }

  _createClass(VirtualBodyRows, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          index = _this$props4.index,
          style = _this$props4.style;
      return _react.default.createElement(VirtualRow, _extends({
        rowStyle: style
      }, data[index].props), data[index].props.children);
    }
  }]);

  return VirtualBodyRows;
}(_react.default.PureComponent);

var VirtualRow =
/*#__PURE__*/
function (_React$PureComponent7) {
  _inherits(VirtualRow, _React$PureComponent7);

  function VirtualRow() {
    _classCallCheck(this, VirtualRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualRow).apply(this, arguments));
  }

  _createClass(VirtualRow, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          rowStyle = _this$props5.rowStyle,
          header = _this$props5.header,
          props = _objectWithoutProperties(_this$props5, ["children", "rowStyle", "header"]);

      return _react.default.createElement(_styler.default, {
        classNames: "co-table__row",
        modifiers: props
      }, function (styles) {
        return _react.default.createElement("div", {
          style: rowStyle,
          className: styles
        }, _react.default.Children.toArray(children).map(function (child, index) {
          return _react.default.createElement(VirtualCell, {
            header: header,
            key: index,
            cell: child
          });
        }));
      });
    }
  }]);

  return VirtualRow;
}(_react.default.PureComponent);

var VirtualCell =
/*#__PURE__*/
function (_React$PureComponent8) {
  _inherits(VirtualCell, _React$PureComponent8);

  function VirtualCell() {
    _classCallCheck(this, VirtualCell);

    return _possibleConstructorReturn(this, _getPrototypeOf(VirtualCell).apply(this, arguments));
  }

  _createClass(VirtualCell, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          cell = _this$props6.cell,
          header = _this$props6.header;
      var _cell$props = cell.props,
          children = _cell$props.children,
          truncated = _cell$props.truncated,
          width = _cell$props.width;
      var cellClasses = [(0, _utils.widthClass)(width), {
        'co-table__cell': !header,
        'co-table__head-cell': header,
        'co-table__column--actions': (0, _compareElementType.default)(cell, _data.ActionData) || (0, _compareElementType.default)(cell, _header.ActionHeader)
      }];
      return _react.default.createElement(_styler.default, _extends({
        classNames: cellClasses,
        modifiers: _objectSpread({
          truncatedCell: truncated
        }, cell.props)
      }, (0, _getNativeProps.default)(cell.props)), function (styles) {
        return _react.default.createElement("div", {
          className: styles
        }, children);
      });
    }
  }]);

  return VirtualCell;
}(_react.default.PureComponent);

VirtualizedTable.displayName = 'Table.Virtualized';
VirtualizedTable.defaultProps = {
  rowHeight: 52,
  headerHeight: 43
};
VirtualizedTable.propTypes = {
  /** {---} Sequence of: @@Table.Head@@(optional, max: 1) @@Table.Body@@(required, min: 1) */
  children: _propTypes.any.isRequired,
  rowHeight: _propTypes.number,
  headerHeight: _propTypes.number,
  sortable: _propTypes.bool,
  striped: _propTypes.bool,
  bordered: _propTypes.bool,
  selectable: _propTypes.bool,
  fontSmall: _propTypes.bool,
  borderless: _propTypes.bool,

  /** Function to generate keys for each row manually. It can receive (index, data) as parameters */
  itemKey: _propTypes.func,

  /** {number} Between 100 and 1000 in increments of 50 */
  scrollableHeight: _utils.scrollableHeightProp
};
var _default = VirtualizedTable;
exports.default = _default;
VirtualizedTable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.Virtualized",
  "props": {
    "rowHeight": {
      "defaultValue": {
        "value": "52",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "headerHeight": {
      "defaultValue": {
        "value": "43",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@Table.Head@@(optional, max: 1) @@Table.Body@@(required, min: 1)"
    },
    "sortable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "striped": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "bordered": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "selectable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fontSmall": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "itemKey": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to generate keys for each row manually. It can receive (index, data) as parameters"
    },
    "scrollableHeight": {
      "type": {
        "name": "custom",
        "raw": "scrollableHeightProp"
      },
      "required": false,
      "description": "{number} Between 100 and 1000 in increments of 50"
    }
  }
};